var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartPad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4353_22443)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.11133,
    y: 8,
    width: 2,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.44336,
    y: 11.3334,
    width: 2,
    height: 10.6667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7773,
    y: 6.66663,
    width: 2,
    height: 15.3333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1113,
    y: 4,
    width: 2,
    height: 18,
    fill: "#03F5AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4353_22443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPad);
export default __webpack_public_path__ + "static/media/chart-pad.77e1d1b5d6cd47d6d4353c4fe284eef6.svg";
export { ForwardRef as ReactComponent };